import {flatMap} from "lodash";
import React, {useEffect, useRef, useState} from "react";
import AGSelect from "../../../components/AgSelect";
import AGButton from "../../../components/Button";
import AGInput from "../../../components/Input";
import AGModal from "../../../components/Modal";
import {compare} from "../../../utils/sort";

import {Formik} from "formik";
import {TextFull} from "../inboxMessage.styled";
import {IMessageModal} from "./messageModal.props";
import AGRadioButtonV2 from "../../../components/RadioButton";
import moment from "moment";
import AGCurrencyInput from "../../../components/CurrencyInput";
import {AddIconCurrencyInput} from "../../../components/AddIconDatePicker";
import {CustomBackground, InquiryDetailStyled} from "./messageModal.styled";
import { OFFERING_TYPE, INQUIRY_MORE_OPTION, OFFERING_TYPE_NAME } from "../../../utils/constant";

const MessageModal: React.FC<IMessageModal> = ({
  inboxDetail,
  toggleModal,
  visible,
  metaData,
  readonly,
  action,
  ...props
}: IMessageModal) => {
  const receiverRegions = flatMap(
    inboxDetail?.receiverRegion,
    (item) => item.agnetRegion?.netRegionName,
  );
  const receiverContries = flatMap(inboxDetail?.receiverRegion, (item) => item.country);
  const isEditData = action === "ADD" || action === "EDIT";
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobileScreen = screenWidth < 769;
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <AGModal
      footer={
        <>
          {!readonly && (
            <AGButton
              type="Primary"
              onClick={toggleModal}
            >
              Save
            </AGButton>
          )}
          <AGButton
            type="Secondary"
            onClick={toggleModal}
          >
            Close
          </AGButton>
        </>
      }
      title={props.title}
      toggleModal={toggleModal}
      visible={visible}
    >
      <CustomBackground ref={componentRef}>
        <InquiryDetailStyled className="p-[1.4286rem] text-[#58585B] mobile2:max-h-none  overflow-y-auto">
          <div className="print">
            <Formik
              initialValues={{
                inquiryDate: inboxDetail?.sendDate
                  ? new Date(`${inboxDetail.sendDate}Z`)
                  : undefined,
                subject: inboxDetail?.subject,
                body: inboxDetail?.body,
                businessGeneratingId: undefined,
                orgId: {
                  value: inboxDetail?.fkFromIndividual?.fkOrg?.orgId,
                  label: inboxDetail?.fkFromIndividual?.fkOrg?.orgName,
                },
                individualId: {
                  value: inboxDetail?.fkFromIndividual?.individualId,
                  label:
                    (inboxDetail?.fkFromIndividual?.firstName ?? "") +
                    " " +
                    (inboxDetail?.fkFromIndividual?.lastName ?? ""),
                },
                toOrgId:
                  inboxDetail?.inboxRecipientsMappings?.map((item) => ({
                    value: item.fkToIndividual?.fkOrg?.orgId,
                    label: item.fkToIndividual?.fkOrg?.orgName,
                  })) || [],
                toIndividualId:
                  inboxDetail?.inboxRecipientsMappings?.map((item) => ({
                    value: item.fkToIndividual?.individualId,
                    label:
                      (item.fkToIndividual?.firstName ?? "") +
                      " " +
                      (item.fkToIndividual?.lastName ?? ""),
                  })) || [],
                offeringType:
                  inboxDetail?.fkComOffering?.fkOfferingType ||
                  inboxDetail?.fkInquiry?.fkMainService
                    ? {
                        value:
                          inboxDetail?.fkComOffering?.fkOfferingType?.offeringTypeId ??
                          inboxDetail?.fkInquiry?.fkMainService?.fkOfferingType?.offeringTypeId,
                        label:
                          inboxDetail?.fkComOffering?.fkOfferingType?.offeringTypeName ??
                          inboxDetail?.fkInquiry?.fkMainService?.fkOfferingType?.offeringTypeName,
                      }
                    : undefined,
                specializedService:
                  inboxDetail?.offeringMainService || inboxDetail?.fkInquiry?.fkMainService
                    ? {
                        value:
                          inboxDetail?.offeringMainService?.mainServiceId ??
                          inboxDetail?.fkInquiry?.fkMainService?.mainServiceId,
                        label:
                          inboxDetail?.offeringMainService?.mainServiceName ??
                          inboxDetail?.fkInquiry?.fkMainService?.mainServiceName,
                      }
                    : undefined,
                specializedProduct:
                  inboxDetail?.offeringMainService || inboxDetail?.fkInquiry?.fkMainService
                    ? {
                        value:
                          inboxDetail?.offeringMainService?.mainServiceId ??
                          inboxDetail?.fkInquiry?.fkMainService?.mainServiceId,
                        label:
                          inboxDetail?.offeringMainService?.mainServiceName ??
                          inboxDetail?.fkInquiry?.fkMainService?.mainServiceName,
                      }
                    : undefined,
                specializedSecondment:
                  inboxDetail?.offeringMainService || inboxDetail?.fkInquiry?.fkMainService
                    ? {
                        value:
                          inboxDetail?.offeringMainService?.mainServiceId ??
                          inboxDetail?.fkInquiry?.fkMainService?.mainServiceId,
                        label:
                          inboxDetail?.offeringMainService?.mainServiceName ??
                          inboxDetail?.fkInquiry?.fkMainService?.mainServiceName,
                      }
                    : undefined,
                status: {
                  value: inboxDetail?.fkInquiryStatus?.inquiryStatusId,
                  label: inboxDetail?.fkInquiryStatus?.status,
                },
                dealValue: inboxDetail?.fkInquiry?.dealValue,
                closeDate: inboxDetail?.fkInquiry?.closeDate
                  ? new Date(`${inboxDetail?.fkInquiry.closeDate}Z`)
                  : undefined,
                senderRegion: {
                  value: inboxDetail?.senderRegion?.agnetRegion?.netRegionName,
                  label: inboxDetail?.senderRegion?.agnetRegion?.netRegionName,
                },
                senderCountry: {
                  value: inboxDetail?.senderRegion?.country,
                  label: inboxDetail?.senderRegion?.country,
                },
                receiverRegion:
                  receiverRegions?.map((item) => ({
                    value: item,
                    label: item,
                  })) || [],
                receiverCountry:
                  receiverContries?.map((item) => ({
                    value: item,
                    label: item,
                  })) || [],
                requestedServices: inboxDetail?.fkInquiry?.fkRequestedServices
                  ? {
                      value: inboxDetail?.fkInquiry?.fkRequestedServices?.requestedServicesTypeId,
                      label: inboxDetail?.fkInquiry?.fkRequestedServices?.requestedServicesTypeName,
                    }
                  : undefined,
                typeOfClient: inboxDetail?.fkInquiry?.fkTypeOfClient
                  ? {
                      value: inboxDetail?.fkInquiry?.fkTypeOfClient?.typeOfClientId,
                      label: inboxDetail?.fkInquiry?.fkTypeOfClient?.typeOfClientName,
                    }
                  : undefined,
                businessGenerating: inboxDetail?.fkInquiry?.fkBusinessGenerating
                  ? {
                      value: inboxDetail?.fkInquiry?.fkBusinessGenerating?.businessGeneratingId,
                      label: inboxDetail?.fkInquiry?.fkBusinessGenerating?.businessGeneratingType,
                    }
                  : undefined,
                onetimeFee: inboxDetail?.fkInquiry?.onetimeFee,
                recurringFee: inboxDetail?.fkInquiry?.recurringFee,
                frequencyOfRecurringFee: inboxDetail?.fkInquiry?.fkFrequencyOfRecurringFee
                  ? {
                      value: inboxDetail?.fkInquiry?.fkFrequencyOfRecurringFee?.frequencyId,
                      label: inboxDetail?.fkInquiry?.fkFrequencyOfRecurringFee?.frequencyType,
                    }
                  : undefined,
                commentsRemarks: inboxDetail?.fkInquiry?.commentsRemarks?.trim(),
                other: inboxDetail?.fkInquiry?.otherNavigation
                  ? {
                      value: inboxDetail?.fkInquiry?.otherNavigation?.offeringTypeId,
                      label: inboxDetail?.fkInquiry?.otherNavigation?.offeringTypeName,
                    }
                  : undefined
              }}
              onSubmit={(values) => {}}
            >
              {({values, errors, setFieldValue}) => {
                return (
                  <div className="innerBox">
                    <div className="flex flex-col pb-2 items-center">
                      <div className="font-semibold w-full mb-2">Inquiry Date</div>
                      <AGInput
                        disabled={readonly}
                        value={moment(values.inquiryDate).format("MM/DD/YYYY") ?? undefined}
                        className="w-full !px-[10px]"
                      />
                    </div>
                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Inquiry Sender Organization</div>
                      <AGSelect
                        isClearable
                        isDisabled={readonly}
                        value={values?.orgId}
                        className="w-full"
                        placeholder="Select organization"
                        options={metaData?.orgAll
                          ?.map((e: any) => {
                            return {
                              value: e.orgId,
                              label: e.orgName,
                            };
                          })
                          .sort((a: any, b: any) => compare(a, b, "label"))}
                        components={{DropdownIndicator: null}}
                      />
                    </div>

                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Inquiry Sender</div>
                      <AGSelect
                        isClearable
                        isDisabled={readonly}
                        value={values?.individualId}
                        className="flex-1"
                        placeholder="Select Inquiry Sender"
                        options={metaData?.individualOfficeAll
                          ?.map((e: any) => {
                            return {
                              value: e.individualId,
                              label: (e.firstName ?? "") + " " + (e.lastName ?? ""),
                            };
                          })
                          .sort((a: any, b: any) => compare(a, b, "label"))}
                        components={{DropdownIndicator: null}}
                      />
                    </div>

                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Inquiry Receiver Organization</div>
                      <AGSelect
                        isClearable
                        isDisabled={readonly}
                        value={values?.toOrgId}
                        className="flex-1"
                        placeholder="Select Receiver"
                        options={metaData?.orgAll
                          ?.map((e: any) => {
                            return {
                              value: e.orgId,
                              label: e.orgName,
                            };
                          })
                          .sort((a: any, b: any) => compare(a, b, "label"))}
                        components={{DropdownIndicator: null}}
                      />
                    </div>

                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Inquiry Receiver</div>
                      <AGSelect
                        isClearable={false}
                        isDisabled={readonly}
                        value={values?.toIndividualId}
                        className="flex-1"
                        isMulti={true}
                        placeholder="Select Inquiry Receivers"
                        options={metaData?.individualOfficeAll
                          ?.map((e: any) => {
                            return {
                              value: e.individualId,
                              label: (e.firstName ?? "") + " " + (e.lastName ?? ""),
                            };
                          })
                          .sort((a: any, b: any) => compare(a, b, "label"))}
                        components={{
                          DropdownIndicator: null,
                          IndicatorSeparator: null,
                          ClearIndicator: undefined,
                          MultiValueRemove: () => null,
                        }}
                      />
                    </div>
                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Sender Country</div>
                      <AGSelect
                        isClearable
                        className="flex-1"
                        options={[values?.senderCountry]}
                        value={values?.senderCountry}
                        isDisabled={true}
                        components={{DropdownIndicator: null}}
                      />
                    </div>
                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Sender Region</div>
                      <AGSelect
                        isClearable
                        className="flex-1"
                        options={[values?.senderRegion]}
                        value={values?.senderRegion}
                        isDisabled={true}
                        components={{DropdownIndicator: null}}
                      />
                    </div>
                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Receiver Country</div>
                      <AGSelect
                        isClearable
                        className="flex-1"
                        options={values?.receiverCountry}
                        value={values?.receiverCountry}
                        isDisabled={true}
                        components={{DropdownIndicator: null}}
                      />
                    </div>
                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Receiver Region</div>
                      <AGSelect
                        isClearable
                        className="flex-1"
                        options={values?.receiverRegion}
                        value={values?.receiverRegion}
                        isDisabled={true}
                        components={{DropdownIndicator: null}}
                      />
                    </div>
                    <div className="flex flex-col py-2">
                      <div className="font-semibold w-full mb-2">Subject</div>
                      {/* <AGInput className="flex-1 w-full" value={values?.subject} disabled={readonly} /> */}
                      <TextFull
                        className="!px-[10px]"
                        isDisabled={readonly}
                        dangerouslySetInnerHTML={{
                          __html:
                            values?.subject?.trim().replace(/</g, "&lt;").replace(/>/g, "&gt;") ??
                            "",
                        }}
                      />
                    </div>

                    <div className="flex flex-col py-2">
                      <div className="font-semibold w-full mb-2">Message</div>
                      <TextFull
                        className="!px-[10px]"
                        isDisabled={readonly}
                        dangerouslySetInnerHTML={{
                          __html:
                            values?.body
                              ?.trim()
                              .replace(/</g, "&lt;")
                              .replace(/>/g, "&gt;")
                              .replace(/\n/g, "<br />") ?? "",
                        }}
                      />
                      {/* <AGTextarea className="flex-1 w-full" rows={5} value={values?.body} disabled={readonly} /> */}
                    </div>

                    {(isEditData || (!isEditData && values?.offeringType)) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Offering Type</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.offeringType}
                          className="flex-1"
                          placeholder="Select Offering type"
                          onChange={(e: any) => {
                            setFieldValue("offeringTypeId", e?.value);
                          }}
                          options={metaData.comOfferingTypes
                            ?.map((e: any) => {
                              return {
                                value: e.offeringTypeId,
                                label: e.offeringTypeName,
                              };
                            })
                            .sort((a: any, b: any) => compare(a, b, "label"))}
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}

                    {values?.other && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Offering Type</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={{
                            value: values?.other.value,
                            label: values.other.label
                          }}
                          className="flex-1"
                          placeholder="Select Offering type"
                          onChange={(e: any) => {
                            setFieldValue("offeringTypeId", e?.value);
                          }}
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}

                    {(values?.offeringType?.value === OFFERING_TYPE.SERVICE || values?.other?.value === OFFERING_TYPE.SERVICE) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Specialized Service</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.other?.value === OFFERING_TYPE.SERVICE ? { value: -1, label: INQUIRY_MORE_OPTION.OTHER } : values.specializedService}
                          className="flex-1"
                          placeholder="Select service"
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}

                    {(values?.offeringType?.value === OFFERING_TYPE.PRODUCT || values?.other?.value === OFFERING_TYPE.PRODUCT) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Specialized Product</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.other?.value === OFFERING_TYPE.PRODUCT ? { value: -1, label: INQUIRY_MORE_OPTION.OTHER } : values.specializedProduct}
                          className="flex-1"
                          placeholder="Select product"
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}

                    {(values?.offeringType?.value === OFFERING_TYPE.SECONDMENT|| values?.other?.value === OFFERING_TYPE.SECONDMENT) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Specialized Service</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.other?.value === OFFERING_TYPE.SECONDMENT ? { value: -1, label: INQUIRY_MORE_OPTION.OTHER } : values.specializedSecondment}
                          className="flex-1"
                          placeholder="Select service"
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}
                    
                    {(isEditData || (!isEditData && values?.requestedServices)) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Requested Services</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.requestedServices}
                          className="flex-1"
                          placeholder="Select Requested services"
                          options={metaData.requestedServices
                            ?.map((e: any) => {
                              return {
                                value: e.requestedServicesTypeId,
                                label: e.requestedServicesTypeName,
                              };
                            })
                            .sort((a: any, b: any) => compare(a, b, "label"))}
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}

                    {(isEditData || (!isEditData && values?.typeOfClient)) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Type of Client</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.typeOfClient}
                          className="flex-1"
                          placeholder="Select type of client"
                          options={metaData.typeOfClient
                            ?.map((e: any) => {
                              return {
                                value: e.typeOfClientId,
                                label: e.typeOfClientName,
                              };
                            })
                            .sort((a: any, b: any) => compare(a, b, "label"))}
                          components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}

                    <div className="flex flex-col py-2 items-center">
                      <div className="font-semibold w-full mb-2">Status</div>
                      <AGSelect
                        isClearable
                        isDisabled={readonly}
                        className="flex-1"
                        placeholder="Select status"
                        value={values?.status}
                        options={metaData.inquiryStatuses
                          ?.map((e: any) => {
                            return {
                              value: e.inquiryStatusId,
                              label: e.status,
                            };
                          })
                          .concat({
                            value: 0,
                            label: "Delete",
                          })
                          .sort((a: any, b: any) => compare(a, b, "label"))}
                        components={{DropdownIndicator: null}}
                      />
                    </div>

                    {/* {(isEditData ||
                      (!isEditData && (values?.dealValue === 0 || values?.dealValue))) && (
                      <div className="flex flex-col py-2">
                        <div className="font-semibold w-full mb-2">Deal Value (USD)</div>
                        <AddIconCurrencyInput>
                          <AGCurrencyInput
                            disabled={readonly}
                            value={values?.dealValue}
                          />
                        </AddIconCurrencyInput>
                      </div>
                    )} */}

                    {/* {(isEditData || (!isEditData && values?.businessGenerating)) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Business Generating?</div>
                        <div className="w-full flex">
                          {metaData?.businessGeneratings?.map((e: any, index: number) => (
                            <div
                              className={`flex items-center ${
                                !isMobileScreen ? "w-1/5" : "w-1/3"
                              } `}
                            >
                              <label className={"flex items-center"}>
                                <AGRadioButtonV2
                                  disabled={true}
                                  checked={
                                    e.businessGeneratingId === values?.businessGenerating?.value
                                  }
                                ></AGRadioButtonV2>
                                <span className="ml-[3px]">{e.businessGeneratingType}</span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )} */}

                    {values?.offeringType?.value !== OFFERING_TYPE.SECONDMENT && (isEditData ||
                      (!isEditData && (values?.onetimeFee === 0 || values?.onetimeFee))) && (
                      <div className="flex flex-col py-2">
                        <div className="font-semibold w-full mb-2">One Time Fee (USD)</div>
                        <AddIconCurrencyInput>
                          <AGCurrencyInput
                            disabled={readonly}
                            value={values?.onetimeFee}
                          />
                        </AddIconCurrencyInput>
                      </div>
                    )}

                    {values?.offeringType?.value !== OFFERING_TYPE.SECONDMENT && (isEditData ||
                      (!isEditData && (values?.recurringFee === 0 || values?.recurringFee))) && (
                      <div className="flex flex-col py-2">
                        <div className="font-semibold w-full mb-2">Recurring Fee (USD)</div>
                        <AddIconCurrencyInput>
                          <AGCurrencyInput
                            disabled={readonly}
                            value={values?.recurringFee}
                          />
                        </AddIconCurrencyInput>
                      </div>
                    )}

                    {values?.offeringType?.value !== OFFERING_TYPE.SECONDMENT && (isEditData || 
                    (!isEditData && values?.frequencyOfRecurringFee)) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Frequency Of Recurring Fee</div>
                        <AGSelect
                          isClearable
                          isDisabled={readonly}
                          value={values?.frequencyOfRecurringFee}
                          className="flex-1 w-full"
                          placeholder="Select Frequency of Recurring fee"
                          options={metaData.frequencyOfRecurringFees
                            ?.map((e: any) => {
                              return {
                                value: e.frequencyId,
                                label: e.frequencyType,
                              };
                            })
                            .sort((a: any, b: any) => compare(a, b, "value"))}
                            components={{DropdownIndicator: null}}
                        />
                      </div>
                    )}
                    
                    {(isEditData || (!isEditData && values?.closeDate)) && (
                      <div className="flex flex-col py-2 items-center">
                        <div className="font-semibold w-full mb-2">Close Date</div>
                        <AGInput
                          className="flex-1 w-full !px-[10px]"
                          disabled={readonly}
                          value={moment(values?.closeDate).format("MM/DD/YYYY") ?? undefined}
                        />
                      </div>
                    )}

                    {(isEditData || (!isEditData && values?.commentsRemarks)) && (
                      <div className="flex flex-col py-2">
                        <div className="font-semibold w-full mb-2">Comments/Remarks (including Estimated Fees, if known)</div>
                        <TextFull
                          className="!px-[10px]"
                          isDisabled={readonly}
                          dangerouslySetInnerHTML={{
                            __html:
                              values?.commentsRemarks
                                ?.trim()
                                .replace(/</g, "&lt;")
                                .replace(/>/g, "&gt;") ?? "",
                          }}
                        />
                      </div>
                    )}
                  </div>
                );
              }}
            </Formik>
          </div>
        </InquiryDetailStyled>
      </CustomBackground>
    </AGModal>
  );
};

export default React.memo(MessageModal);
